import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalBody
} from "@chakra-ui/react";

export default function Modal({
  isOpen,
  onClose,
  contentProps,
  modalProps,
  bodyProps,
  children
}) {
  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} isCentered {...modalProps}>
      <ModalOverlay />
      <ModalContent {...contentProps}>
        <ModalBody {...bodyProps}>{children}</ModalBody>
      </ModalContent>
    </ChakraModal>
  );
}
